export function nextFrame() {
  return new Promise((resolve) => requestAnimationFrame(() => resolve()));
}

export function nextTick() {
  return new Promise((resolve) => setTimeout(() => resolve(), 0));
}

export function nextMicrotask() {
  return Promise.resolve();
}
